let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e6MGH")).then(() => parcelRequire('e9JYy'));